import { localizedVariants } from "@/lib/localized-route-slugs"

/**
 * The checker hub's last path segment in every locale it's served under —
 * `insurance`, plus `versicherung` / `assurance`. Derived from the localized
 * slug registry rather than listed here, so adding a locale can't leave one
 * variant behind still showing what the others suppress.
 */
const CHECKER_SEGMENTS = new Set(
  ["/insurance", ...localizedVariants("/insurance")].map((p) => p.slice(1))
)

/**
 * True on the coverage checker hub itself (`/{country}/{locale}/insurance`),
 * not its children.
 *
 * Two floating things are suppressed here and nowhere else (Nadjib, INS-3):
 * the proactive chat teaser and the exit-intent modal. Both fired while people
 * were still filling the form — on a phone they land directly on top of the
 * fields, and they can arrive together — and neither earned the interruption.
 * The teaser was shown to 1,176 visitors on the checker, opened by 88, and
 * actively dismissed by nearly a third. Exit-intent was shown to 484 since
 * June: 61 clicked one of its CTAs and none of those went on to book.
 *
 * The chat launcher itself stays, so anyone who wants a conversation can still
 * start one.
 */
export function isCoverageCheckerPath(pathname: string): boolean {
  const segments = pathname.split("/").filter(Boolean)
  return segments.length === 3 && CHECKER_SEGMENTS.has(segments[2])
}
